/**
 * @generated SignedSource<<4412a0616c566d63806e5e00d935e8d4>>
 * @relayHash 106ffcdbdc9ff700e1f7193373d8211c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21bcf8f16440b9445010d83b264fa7e47aeecee045ee1c72d7c44932b4fea62a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceLength = "LONG" | "MEDIUM" | "SHORT" | "%future added value";
export type ConfluenceTone = "CONVERSATIONAL" | "PLAYFUL" | "PROFESSIONAL" | "SURPRISE" | "%future added value";
export type AudioContainerQuery$variables = {
  cloudId: string;
};
export type AudioContainerQuery$data = {
  readonly confluence_getAudioPreference: {
    readonly length: ConfluenceLength;
    readonly playbackSpeed: number;
    readonly tone: ConfluenceTone;
  } | null | undefined;
};
export type AudioContainerQuery = {
  response: AudioContainerQuery$data;
  variables: AudioContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceAudioPreference",
    "kind": "LinkedField",
    "name": "confluence_getAudioPreference",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "tone"
      },
      {
        "kind": "ScalarField",
        "name": "length"
      },
      {
        "kind": "ScalarField",
        "name": "playbackSpeed"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AudioContainerQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AudioContainerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "21bcf8f16440b9445010d83b264fa7e47aeecee045ee1c72d7c44932b4fea62a",
    "metadata": {},
    "name": "AudioContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8e9349dd0b657ff897c93848ef50d4f6";

export default node;
